const SidebarModal = ({FilterBar}) => {
  return (
    <div
      className="offcanvas offcanvas-start offcanvas-listing-sidebar"
      tabIndex="-1"
      id="sidebarListing"
    >
    <div className="offcanvas-header">
      <h5 className="offcanvas-title">Advanced Search</h5>
      <button
        type="button"
        className="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>
      <div className="offcanvas-body">
        <div className="sidebar_listing_grid1">
          <div className="sidebar_listing_list">
            <div className="sidebar_advanced_search_widget">
            <FilterBar isMobView={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarModal;
